import React, { useContext, useEffect, useState } from 'react';
import { TeamsSubMenu } from '../Teams/TeamsSubMenu';
import { EmployeeListTrial } from '../Employees/EmployeeListTrial';
import { Button, Dimmer, Dropdown, Loader, Modal, Checkbox, Embed } from 'semantic-ui-react';
import { AppContext } from '../../context/app/appContext';
import { FileDropZone } from '../common/FileDropZone';
import { TopBar } from '../common/TopBar';
import { Sidebar } from '../common/Sidebar';
import { EmployeeDetails } from '../Employees/EmployeeDetails';
import { useFormik } from "formik";
import { addSingleEmployeeFormValidationSchema } from "../../utilities/Validations";
import axios from 'axios';
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';

const EmployeesPageComponentTrial = (props) => {

    const appContext = useContext(AppContext);
    const [employees, setEmployees] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    const [totalEmployeesCount, setTotalEmployeesCount] = useState(0);
    const [activeEmployeesCount, setActiveEmployeesCount] = useState(0);
    const [frozenEmployeesCount, setFrozenEmployeesCount] = useState(0);
    const [signedInEmployeesCount, setSignedInEmployeesCount] = useState(0);

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [infoModalText, setInfoModalText] = useState('');
    const [infoModalData, setInfoModalData] = useState(null);

    const [allEmployeeSelection, setAllEmployeeSelection] = useState(false);
    const [selectedEmployeesCount, setSelectedEmployeesCount] = useState(0);

    const dimmer = 'blurring';
    const history = useHistory();
    const [showAddSingleEmployeeModal, setShowAddSingleEmployeeModal] = useState(false);
    const [showBulkUploadEmployeeModal, setShowBulkUploadEmployeeModal] = useState(false);
    const [teamList, setTeamList] = useState([]);
    const [selectedTeamId, setSelectedTeamId] = useState('');
    const [showSaveModal, setShowSaveModal] = useState(false)
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

    const [cardCount, setcardCount] = useState(0)
    const maxCards = appContext.organization.pilotCardLimit || 10
    // const [empToDisplay, setEmpToDisplay] = useState(appContext.employees.filter(emp => {return emp.teamId === undefined || emp.teamId.length === 0}).concat(appContext.employees.filter(emp => {return emp.teamId !== undefined && emp.teamId.length > 0})))

    const showAddAnEmployeeModal = () => setShowAddSingleEmployeeModal(true);

    useEffect(() => {
        var tot = 0
        if(appContext.employees){
            appContext.employees.forEach(employee => {
                if (employee.role === 'employee' || employee.role === 'perk-manager') {tot += 1}
                if (employee.expenseStatus !== "none") {tot += 1}
            })
        }
        setcardCount(tot)
        console.log("Total cards = ", tot)
    }, [appContext.employees])

    const addSingleEmployeeForm = useFormik({
        initialValues: {
            newEmployeeFirstName: '',
            newEmployeeLastName: '',
            newEmployeeContactNumber: '',
            newEmployeeEmail: '',
        },
        validationSchema: addSingleEmployeeFormValidationSchema,
        onSubmit: async (values) => {
            // alert(JSON.stringify(values, null, 2));
            setShowAddSingleEmployeeModal(false);
            addSingleEmployeeForm.resetForm();
            const result = await appContext.addEmployee({
                email: addSingleEmployeeForm.values.newEmployeeEmail,
                firstName: addSingleEmployeeForm.values.newEmployeeFirstName,
                lastName: addSingleEmployeeForm.values.newEmployeeLastName,
                contactNumber: addSingleEmployeeForm.values.newEmployeeContactNumber,
            });
            if(!result) toast.error(`Could not add ${addSingleEmployeeForm.values.newEmployeeFirstName + ' ' + addSingleEmployeeForm.values.newEmployeeLastName} employee.`, {autoClose: 3000});
            else toast.success(`'${addSingleEmployeeForm.values.newEmployeeFirstName + ' ' + addSingleEmployeeForm.values.newEmployeeLastName}' has been added.`, {autoClose: 3000});
        },
    });



    useEffect(() => {
        const tempEmployees = (appContext.employees.filter(emp => { return emp.teamId === undefined || emp.teamId.length === 0 }).concat(appContext.employees.filter(emp => { return emp.teamId !== undefined && emp.teamId.length > 0 })));

        setEmployees(tempEmployees.map(emp => { return { ...emp, perkCardSelected: true ? emp.role === 'employee' || emp.role === 'perk-manager' : false, expenseCardSelected: true ? emp.expenseStatus !== 'none' : false } }));
        // setEmpToDisplay(appContext.employees.filter(emp => {return emp.teamId === undefined || emp.teamId.length === 0}).concat(appContext.employees.filter(emp => {return emp.teamId !== undefined && emp.teamId.length > 0})))
        console.info({ employees });

        let activeEmployees = 0;
        let frozenEmployees = 0;
        let signedInEmployees = 0;
        for (const employee of appContext.employees) {
            if (employee.status === 'active') activeEmployees++;
            if (employee.status === 'inactive') frozenEmployees++;
            if (!employee.lastLoginAt) signedInEmployees++;
        }

        setTotalEmployeesCount(appContext.employees.length);
        setActiveEmployeesCount(activeEmployees);
        setFrozenEmployeesCount(frozenEmployees);
        setSignedInEmployeesCount(signedInEmployees);

        // eslint-disable-next-line
    }, [appContext.employees]);

    useEffect(() => {
        const tempEmployees = (appContext.employees.filter(emp => { return emp.teamId === undefined || emp.teamId.length === 0 }).concat(appContext.employees.filter(emp => { return emp.teamId !== undefined && emp.teamId.length > 0 })));

        setEmployees(tempEmployees.map(emp => { return { ...emp, perkCardSelected: true ? emp.role === 'employee' || emp.role === 'perk-manager' : false, expenseCardSelected: true ? emp.expenseStatus !== 'none' : false } }));
        // setEmpToDisplay(appContext.employees.filter(emp => {return emp.teamId === undefined || emp.teamId.length === 0}).concat(appContext.employees.filter(emp => {return emp.teamId !== undefined && emp.teamId.length > 0})))
        console.info({ employees });

        let activeEmployees = 0;
        let frozenEmployees = 0;
        let signedInEmployees = 0;
        for (const employee of appContext.employees) {
            if (employee.status === 'active') activeEmployees++;
            if (employee.status === 'inactive') frozenEmployees++;
            if (!employee.lastLoginAt) signedInEmployees++;
        }

        setTotalEmployeesCount(appContext.employees.length);
        setActiveEmployeesCount(activeEmployees);
        setFrozenEmployeesCount(frozenEmployees);
        setSignedInEmployeesCount(signedInEmployees);

        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        (async function loadEmployees() {
            if (appContext.employees.length === 0)
                await appContext.setEmployees();
        })();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // console.info({allEmployeeSelection});
        if (employees && allEmployeeSelection) selectedAllEmployees(true);
        if (employees && !allEmployeeSelection) selectedAllEmployees(false);
        // eslint-disable-next-line
    }, [allEmployeeSelection]);

    useEffect(() => {
        if(employees){
            setSelectedEmployeesCount(employees.filter(employee => employee.selected).length);
        }
        
        // eslint-disable-next-line
    }, [employees]);

    useEffect(() => {
        const teamList = appContext.teams.map(team => {
            return { key: team.id, value: team.id, text: team.name };
        });
        setTeamList(teamList);
        // setSelectedTeamClick(teamList);
        // setSelectedTeamId(teamList[0].value);
        // eslint-disable-next-line
    }, [appContext.teams]);

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
            })();
        }
        // eslint-disable-next-line
    }, []);

    function selectedAllEmployees(select = true) {
        const allEmployeesSelected = employees.map(employee => {
            if(employee.role === 'employee' || employee.role === 'perk-manager') return { ...employee, selected: select }
            else return employee
            // return { ...employee, selected: select };
        });
        setEmployees(allEmployeesSelected);
    }

    const addSelectedEmployeesToTeam = async (e) => {
        const selectedEmployeesIds = employees.filter(employee => employee.selected).map(employee => employee.id);
        console.info({ selectedTeamId });
        console.info({ selectedEmployeesIds });
        if (!selectedTeamId) alert(`Please select a team first.`);
        const selectedTeam = teamList.filter(team => {return team.key === selectedTeamId})[0]
        const addedToTeam = await appContext.addEmployeesToTeam(selectedEmployeesIds, selectedTeamId);
        console.info({ addedToTeam });
        console.info({addedToTeam});
        if(!addedToTeam) toast.error(`There was some error. Please try again.`, {autoClose: 3000});
        else{
            const successEmployees = addedToTeam.filter(emp => {return emp.success});
            const failEmployees = addedToTeam.filter(emp => {return !emp.success});
            if(successEmployees.length) toast.success(`Successfully added ${successEmployees.length} employees to ${selectedTeam.text}`, {autoClose: 3000});
            if(failEmployees.length){
                for(const item of failEmployees){
                    toast.warning(`Failed to add ${item.name} to ${selectedTeam.text} due to absence of Perk Budget and/or Expense Limit in New Team.`, {autoClose: 3000});
                }
            }
        }
    }

    const onSubmitEmployeeBulkUploadForm = async (e) => {
        e.preventDefault();
    };

    const handleEmployeeSelectionChange = (employeeId, selected) => {
        console.info(`@ handleEmployeeSelectionChange - employeeId:${employeeId} selected:${!selected}`);
        const selectedTeams = employees.map(employee => {
            if (employee.id === employeeId && (employee.role !== "employee-ft" || employee.role !== 'perk-manager-ft')) return { ...employee, selected: !selected };
            return employee;
        });
        // console.clear();
        // console.table(selectedTeams);
        setEmployees(selectedTeams);
    };

    const handleEmployeePerkCardSelectionChange = (employeeId, perkCardSelected) => {
        console.info(`@ handleEmployeePerkCardSelectionChange - employeeId:${employeeId} perkCardSelected:${!perkCardSelected}`);

        const updateEmployess = employees.map(employee => {
            if (employee.id === employeeId && (employee.role !== 'employee' || employee.role !== 'perk-manager')) {

                if (perkCardSelected === true && employee.expenseCardSelected === true) {
                    if (cardCount > 0) setcardCount((count) => count - 2)
                    return { ...employee, perkCardSelected: !perkCardSelected, expenseCardSelected: false };
                } else if (perkCardSelected === true && employee.expenseCardSelected === false) {
                    if (cardCount > 0) setcardCount((count) => count - 1)
                    return { ...employee, perkCardSelected: !perkCardSelected, expenseCardSelected: false };
                }
                if (cardCount < maxCards) {
                    setcardCount((count) => count + 1)
                    return { ...employee, perkCardSelected: !perkCardSelected };
                }
            }
            return employee;
        });
        setEmployees(updateEmployess)
    };
    const handleEmployeeExpenseCardSelectionChange = (employeeId, expenseCardSelected) => {
        console.info(`@ handleEmployeePerkCardSelectionChange - employeeId:${employeeId} expenseCardSelected:${!expenseCardSelected}`);

        const updateEmployess = employees.map(employee => {
            if (employee.id === employeeId && employee.perkCardSelected === true) {
                if (expenseCardSelected === true) {
                    if (cardCount > 0) setcardCount((count) => count - 1)
                    return { ...employee, expenseCardSelected: !expenseCardSelected };
                }
                if (cardCount < maxCards) {
                    setcardCount((count) => count + 1)
                    return { ...employee, expenseCardSelected: !expenseCardSelected };
                }
            }
            return employee;
        });
        setEmployees(updateEmployess)
    };

    const handleSave = async () => {
        const selected = (employees.filter(employee => {return employee.perkCardSelected})).map(employee => {return { employeeId: employee.id, expenseCardSelected: employee.expenseCardSelected, perkCardSelected: employee.perkCardSelected, role: employee.role }})

        console.info({selected})
        let temp = await axios.post(baseURL + '/changeEmployeeRole', { selected }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })
        setShowSaveModal(false);
        await appContext.setEmployees();
        if(temp.status === 200){
            toast.success(`Successfully saved.`, {autoClose: 3000});
        }else{
            toast.error(`There was some error. Please try again.`, {autoClose: 3000});
        }
    }

    const handleCsvUpload = async (file) => {
        setShowBulkUploadEmployeeModal(false);
        const uploaded = await appContext.bulkUploadEmployees(file);
        console.info({ uploaded });

        if (!uploaded) return csvFailed();

        const { code, message, data } = uploaded;

        if (!(code && message)) return csvFailed();

        appContext.setLoading(false);
        setInfoModalText(message);
        setInfoModalData(data)
        setShowInfoModal(true);
        await appContext.setEmployees();
    }

    const csvFailed = () => {
        appContext.setLoading(false);
        setInfoModalText('Unable to process CSV. Please verify the format & values & try again.');
        setShowInfoModal(true);
        return null;
    }

    // const handleCheckboxClick = (v) => {
    //     console.log(v)
    //     if(v.checked){
    //         setEmpToDisplay(employees.filter(emp => {return emp.teamId === undefined || emp.teamId.length === 0}))
    //     }else{
    //         setEmpToDisplay(employees)
    //     }
    // }

    const handleSeeEmployeeDetails = (employeeId) => {
        history.push(`/programs/employees/${employeeId}`)
    }
    return (
        <div id="app" style={{ marginRight: 0, paddingRight: 0 }}>

            {/* {!selectedEmployee ? */}
            <div>
                <div id="employees-page" className="dashboard-page">
                    {appContext.loading && (<Dimmer active inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>)}

                    <div className="ui grid" style={{width: '100%'}}>
                        <div className="twelve wide column" id="team-management" style={{ marginRight: 0, paddinRight: 0 }}>
                            <div className="ui segment" style={{ backgroundColor: 'transparent', marginRight: 0, paddinRight: 0, borderWidth: 0, borderBottomColor: 'transparent', WebkitBoxShadow: 'none' }}>
                                <div className="ui secondary menu" style={{ marginRight: 0, paddinRight: 0, borderWidth: 0, borderBottomColor: 'transparent' }}>
                                    <div className="item add-to-team-dropdown">
                                        <span>Add to Team:</span>
                                        <Dropdown
                                            placeholder='Select Team'
                                            search selection clearable
                                            disabled={!selectedEmployeesCount}
                                            options={teamList} value={selectedTeamId} onChange={(e, { value }) => setSelectedTeamId(value)} />
                                        {selectedTeamId && selectedEmployeesCount ?
                                            <div className="item">
                                                <button className="ui button" onClick={addSelectedEmployeesToTeam}>Add</button>
                                            </div>
                                            : ''
                                        }
                                    </div>
                                    <div className="right menu">
                                        <div className="item" style={{ fontSize: 20, color: '' }}>{selectedEmployeesCount ? selectedEmployeesCount + ' Employees Selected' : ''}</div>
                                        <div className="item">
                                            <button className="ui button" onClick={event => setShowBulkUploadEmployeeModal(true)}>Bulk Upload</button>
                                        </div>
                                        <div className="item">
                                            <button className="ui button" onClick={showAddAnEmployeeModal}>Add Employee</button>
                                        </div>
                                        <div className="item">
                                            <button className="ui button" disabled={cardCount < 3 || cardCount > maxCards || (function temp(){
                                                                                                            var tot = 0;
                                                                                                            appContext.employees.forEach(employee => {
                                                                                                                if (employee.role === 'employee' || employee.role === 'perk-manager') {tot += 1}
                                                                                                                if (employee.expenseStatus !== "none") {tot += 1}
                                                                                                            })
                                                                                                            console.log("Check this: ", tot === cardCount)
                                                                                                            return tot === cardCount;
                                                                                                        })()} 
                                                onClick={() => setShowSaveModal(true)}>Save</button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {(employees && <EmployeeListTrial employees={employees}
                                handleSeeEmployeeDetails={handleSeeEmployeeDetails}
                                maxCards={maxCards}
                                setSelectedEmployee={setSelectedEmployee}
                                cardCount={cardCount}
                                onEmployeeSelect={handleEmployeeSelectionChange}
                                onPerkCardSelect={handleEmployeePerkCardSelectionChange}
                                onExpenseCardSelect={handleEmployeeExpenseCardSelectionChange}
                                allEmployeesSelected={allEmployeeSelection}
                                onAllEmployeesToggle={e => setAllEmployeeSelection(
                                    !allEmployeeSelection)} />)}
                        </div>
                        <div className="four wide column" style={{fontStyle: 'SFProText-Regular', paddingRight: 10, textAlign: 'justify', paddingTop: 30}}>
                            <div style={{fontSize: 24, fontWeight: '900'}}>Important Note</div>
                            <p style={{color: '#FF5A5F', fontSize: 16, marginTop: 5}}>Changes on Perk and Expnse Card selection are not permitted after the options are saved. Please choose carefully before saving.</p>
                            <p style={{fontSize: 16}}>
                                1. Minimum of 3 and maximum of {maxCards} cards can be assigned to the employees.
                            </p>
                            <p style={{fontSize: 16}}>
                                2. An employee needs to be a Perk Card holder to be eligible for an Expense Card.
                            </p>
                            <p style={{fontSize: 16}}>
                                3. Once cards are allocated to the employees, select and assign them to their respective teams.
                            </p>
                            <p style={{fontSize: 16}}>
                                4. Employees with a complete profile (Perk Card, Teams) can now login to their employee app, enter their shipping and billing info to receive perk/expense cards.
                            </p>
                            <p style={{fontSize: 16}}>
                                5. Expense Cards can be shipped for an Employee from the Employee Details after they have logged in on the App.
                            </p>
                        </div>
                    </div>
                    
                </div>

                <Modal dimmer={dimmer} open={showAddSingleEmployeeModal}
                    size="small" onClose={addSingleEmployeeForm.resetForm}>
                    <Modal.Content><p>Import from your payroll provider</p>
                        <button className="ui button primary">Connect with Payroll Provider</button>
                        <h2>OR</h2>
                        <form className="ui form"
                            onSubmit={addSingleEmployeeForm.handleSubmit}>
                            <div className="ui field fluid">Employee Details</div>
                            <div className="ui two wide fields">
                                <div className={`field ${addSingleEmployeeForm.errors.newEmployeeFirstName && addSingleEmployeeForm.touched.newEmployeeFirstName ? 'error' : ''}`}><input
                                    required type="text"
                                    className="ui input"
                                    placeholder="First Name"
                                    name="newEmployeeFirstName"
                                    id="newEmployeeFirstName"
                                    value={addSingleEmployeeForm.values.newEmployeeFirstName}
                                    onChange={addSingleEmployeeForm.handleChange} onBlur={addSingleEmployeeForm.handleBlur} />
                                    <div className="error-message">{addSingleEmployeeForm.touched.newEmployeeFirstName ? addSingleEmployeeForm.errors.newEmployeeFirstName : ''}</div>
                                </div>
                                <div className={`field ${addSingleEmployeeForm.errors.newEmployeeLastName && addSingleEmployeeForm.touched.newEmployeeLastName ? 'error' : ''}`}>
                                    <input required
                                        type="text"
                                        className="ui input"
                                        placeholder="Last Name"
                                        name='newEmployeeLastName'
                                        id='newEmployeeLastName'
                                        value={addSingleEmployeeForm.values.newEmployeeLastName}
                                        onChange={addSingleEmployeeForm.handleChange}
                                        onBlur={addSingleEmployeeForm.handleBlur} />
                                    <div className="error-message">{addSingleEmployeeForm.touched.newEmployeeLastName ? addSingleEmployeeForm.errors.newEmployeeLastName : ''}</div>
                                </div>
                            </div>
                            <div className="ui two wide fields">
                                <div className={`field ${addSingleEmployeeForm.errors.newEmployeeContactNumber && addSingleEmployeeForm.touched.newEmployeeContactNumber ? 'error' : ''}`}>
                                    <input required type="text"
                                        className="ui input"
                                        placeholder="Contact Number"
                                        name='newEmployeeContactNumber'
                                        id='newEmployeeContactNumber'
                                        value={addSingleEmployeeForm.values.newEmployeeContactNumber}
                                        onChange={addSingleEmployeeForm.handleChange} onBlur={addSingleEmployeeForm.handleBlur} />
                                    <div
                                        className="error-message">{addSingleEmployeeForm.touched.newEmployeeContactNumber ? addSingleEmployeeForm.errors.newEmployeeContactNumber : ''}</div>
                                </div>
                                <div className={`field ${addSingleEmployeeForm.errors.newEmployeeEmail && addSingleEmployeeForm.touched.newEmployeeEmail ? 'error' : ''}`}>
                                    <input required
                                        type="text"
                                        className="ui input"
                                        placeholder="Work email"
                                        name='newEmployeeEmail'
                                        id='newEmployeeEmail'
                                        value={addSingleEmployeeForm.values.newEmployeeEmail}
                                        onChange={addSingleEmployeeForm.handleChange}
                                        onBlur={addSingleEmployeeForm.handleBlur} />
                                    <div className="error-message">{addSingleEmployeeForm.touched.newEmployeeEmail ? addSingleEmployeeForm.errors.newEmployeeEmail : ''}</div>
                                </div>
                            </div>
                            <br />

                            <div className="ui two wide fields">
                                <div className="field">
                                    <Button className="right floated" type="button" onClick={() => setShowAddSingleEmployeeModal(false)}>Cancel</Button>
                                </div>
                                <div className="field">
                                    <Button className="left floated" type="submit" disabled={Object.keys(addSingleEmployeeForm.touched).length === 0 ||
                                        Object.keys(addSingleEmployeeForm.errors).length > 0}>Create Profile</Button>
                                </div>
                            </div>
                        </form>

                        {/*<section>
                                        <p>{`Object.keys(addSingleEmployeeForm.touched).length : ${Object.keys(addSingleEmployeeForm.touched).length}`}</p>
                                        <p>{`Object.keys(addSingleEmployeeForm.errors).length : ${Object.keys(addSingleEmployeeForm.errors).length}`}</p>
                                        <p>{JSON.stringify(addSingleEmployeeForm.errors)}</p>
                                    </section>*/}

                    </Modal.Content>
                </Modal>


                <Modal dimmer={dimmer} open={showBulkUploadEmployeeModal} size="small" onClose={onSubmitEmployeeBulkUploadForm}>
                    <Modal.Content>
                        <a href="/assets/csv/sample-employees.csv" className="icon button right floated" download><i className="icon download" /> Download Sample CSV</a>
                        <br />
                        <FileDropZone onFileGiven={handleCsvUpload} />
                        <Button className="center aligned" type="button" onClick={() => setShowBulkUploadEmployeeModal(false)}>Cancel</Button>
                        <br />
                    </Modal.Content>
                </Modal>

                <Modal dimmer={dimmer} open={showSaveModal} size="small" onClose={() => setShowSaveModal(false)}>
                    <Modal.Content>
                        <p>
                            <div style={{ color: '#FF5A5F' }}>Please confirm your selection:</div>
                        </p>
                    </Modal.Content>
                    <Modal.Actions className="center aligned"><Button onClick={() => setShowSaveModal(false)}>Cancel</Button></Modal.Actions>
                    <Modal.Actions className="center aligned"><Button onClick={() => handleSave()}>Confirm</Button></Modal.Actions>
                </Modal>

                <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                    <Modal.Content><p>{infoModalText}</p></Modal.Content>
                    {infoModalData ?
                        <Modal.Content>
                            <p><div style={{ color: '#00CF8F' }}>Successfully Uploaded ({infoModalData['success'].length}):</div>
                                <div>{infoModalData['success'].map(name => { return <div>{name}</div> })}</div></p>
                            <p><div style={{ color: '#FF5A5F' }}>Failed to upload ({infoModalData['fail'].length}):</div>
                                <div>{infoModalData['fail'].map(name => { return <div>{name}</div> })}</div></p>
                        </Modal.Content>
                        : null}
                    <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
                </Modal>

            </div>
            {/* :
                        <div id="content" className="thirteen wide column">
                            <EmployeeDetails employee={selectedEmployee}/>
                        </div>
                    } */}
            {/* </div>
            </div> */}
        </div>
    );
};

export const EmployeesPageTrial = EmployeesPageComponentTrial;

